import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { login, clearError } from '../store/authSlice';
import NetworkBackground from '../components/NetworkBackground';
import '../styles/Login.css';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [mfaCode, setMfaCode] = useState('');
  const [showMfa, setShowMfa] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, loading, error } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    if (error === 'MFA code required') {
      setShowMfa(true);
    }
  }, [error]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(clearError());
    
    const result = await dispatch(login({ 
      username, 
      password, 
      mfa_code: showMfa ? mfaCode : undefined 
    }));
    
    if (result.payload?.mfa_required) {
      setShowMfa(true);
    }
  };

  return (
    <div className="login-page">
      <div className="login-background">
        <NetworkBackground density={0.85} />
      </div>
      
      <div className="login-container">
        <div className="login-header">
          <Link to="/" className="login-back-link">← Platform overview</Link>
          <div className="login-logo">
            <img src="/logo.png" alt="Hivemind Subterfuge Platform" className="login-logo-image" />
          </div>
          <p className="login-subtitle">Hivemind Subterfuge Platform</p>
          <div className="login-warning">
            ⚠️ AUTHORIZED PERSONNEL ONLY 
          </div>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          {error && !showMfa && (
            <div className="login-error">
              <span>⚠️</span> {error}
            </div>
          )}

          <div className="form-group">
            <label className="form-label">OPERATOR ID</label>
            <input
              type="text"
              className="form-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label className="form-label">ACCESS KEY</label>
            <input
              type="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
            />
          </div>

          {showMfa && (
            <div className="form-group">
              <label className="form-label">MFA CODE</label>
              <input
                type="text"
                className="form-input"
                value={mfaCode}
                onChange={(e) => setMfaCode(e.target.value)}
                placeholder="Enter 6-digit code"
                maxLength={6}
                autoFocus
              />
            </div>
          )}

          <button 
            type="submit" 
            className="btn btn-primary btn-lg login-btn"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="loader-small"></span>
                AUTHENTICATING...
              </>
            ) : (
              <>
                <span>🔐</span>
                INITIALIZE SESSION
              </>
            )}
          </button>
        </form>

        <div className="login-footer">
          <p>Hivemind Subterfuge Platform v1.0.0</p>
          <p className="login-legal">
            This system is for authorized operators only.
            Unauthorized access is prohibited and may be prosecuted.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
